import type { RegistryEntry } from '../types';
import { sanitizeSubtitleAreas } from '../../baidu-vod/subtitle-areas';

const SUBTITLE_TYPES = ['dialog', 'global', 'manual'] as const;
const MODEL_TYPES = ['v3', 'v4'] as const;

export const baiduVodConfigs: Record<string, RegistryEntry> = {
    'video-desubtitle': {
        options: [
            {
                key: 'subtitle_type',
                label: 'Erase type',
                type: 'select',
                options: [
                    // dialog: 对白字幕擦除；global: 全局文字擦除；manual: 手动选区（区域内全擦除，
                    // 选区经工具栏首帧框选弹窗写入 modelUi.subtitle_areas）
                    // label 作为 i18n key，渲染层经 t() 翻译
                    { label: 'Dialogue subtitles', value: 'dialog' },
                    { label: 'All on-screen text', value: 'global' },
                    { label: 'Manual area', value: 'manual' },
                ],
                default: 'dialog',
                group: 'inline',
            },
            {
                key: 'desubtitle_model',
                label: 'Model version',
                type: 'select',
                options: [
                    // v3 默认；v4 效果更好但耗时更长
                    { label: 'v3 · Fast', value: 'v3' },
                    { label: 'v4 · High quality (slower)', value: 'v4' },
                ],
                default: 'v3',
                group: 'inline',
            },
        ],
        toProviderOptions: (ui) => {
            const rawType = typeof ui.subtitle_type === 'string' ? ui.subtitle_type.trim() : '';
            const rawModel = typeof ui.desubtitle_model === 'string' ? ui.desubtitle_model.trim() : '';
            const type = (SUBTITLE_TYPES as readonly string[]).includes(rawType) ? rawType : 'dialog';
            // manual 依赖有效选区（areaList 必填）；无选区时（如节点上手动切换）回退对白擦除
            const areas = type === 'manual' ? sanitizeSubtitleAreas(ui.subtitle_areas) : undefined;
            return {
                subtitle_type: type === 'manual' && !areas ? 'dialog' : type,
                desubtitle_model: (MODEL_TYPES as readonly string[]).includes(rawModel) ? rawModel : 'v3',
                ...(areas ? { subtitle_areas: areas } : {}),
            } as unknown as Record<string, Record<string, any>>;
        },
    },
};
